<template>
<div class="modals">
  <component v-for="(modal, index) in modals"
            :data="modal.data"
            :active="modal.active"
            :is="modal.name"
            :key="modal.name"
            :class="{'modal-uppermost': index + 1 === modals.length }"
            @closed="remove(modal.name)"/>
</div>
</template>

<script>
import modalsRegistered from '../mixins/modalsRegistered';

export default {
  mixins: [modalsRegistered],

  data() {
    return {
      modals: [],
    };
  },

  watch: {
    modals() {
      if (this.modals.length) {
        document.body.classList.add('modal-active');
      } else {
        document.body.classList.remove('modal-active');
      }
    },
  },

  mounted() {
    Event.listen('toggleModal', (name, state, data) => {
      if (!name) {
        return this.close();
      }

      const modalName = this.getModalName(name);

      switch (state) {
        case true:
          return this.open(modalName, data);
        case false:
          return this.close(modalName);
        default:
          return this.toggle(modalName, data);
      }
    });
  },

  methods: {
    open(name, data) {
      if (!this.hasModal(name)) {
        this.modals.push({ name, data, active: true });
      }
    },

    close(name = null) {
      if (!name) {
        this.modals.forEach(modal => this.setActive(modal.name, false));
      }
      if (name && this.hasModal(name)) {
        this.setActive(name, false);
      }
    },

    toggle(name, data) {
      return this.hasModal(name) ? this.close(name) : this.open(name, data);
    },

    remove(name) {
      return this.modals.splice(this.findIndex(name), 1);
    },

    getModalName(name) {
      return `modal-${name}`;
    },

    hasModal(name) {
      return this.findIndex(name) !== -1;
    },

    findIndex(name) {
      return this.modals.findIndex(modal => modal.name === name);
    },

    setActive(name, boolean) {
      this.modals[this.findIndex(name)].active = boolean;
    },
  },
};
</script>
